module.exports = __webpack_public_path__ + "static/media/guides.f3eee4f6.jpg";